import type { ReactNode } from 'react';

import IntersectionReveal from '../intersection/IntersectionReveal';

type Props = {
  children: ReactNode;
  delay?: number;
  duration?: number;
  ease?: string;
  mask?: boolean;
  once?: boolean;
  opacity?: number;
  scale?: number;
};

export default function AniScaleUp({
  children,
  delay = 0,
  duration = 0.5,
  ease = 'power1.out',
  mask = false,
  once = true,
  opacity = 1,
  scale = 1.1,
}: Props) {
  return (
    <IntersectionReveal
      delay={delay}
      duration={duration}
      ease={ease}
      hiddenOpacity={opacity}
      mask={mask}
      once={once}
      visibleTransform={`scale(${scale})`}
    >
      {children}
    </IntersectionReveal>
  );
}
